import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.module.scss';
import SubmissionButton from './SubmissionButton';
import DealershipSummary from '../../DealershipSummary';

export const CheckoutSummaryHeader = ({
  title,
  checkoutProcessString,
  productionPeriod,
  inCartView,
}) => (
  <div className={styles.checkoutSummary}>
    <div className={styles.checkoutHeader}>
      <div>
        <h1 className={styles.checkoutTitle}>{title}</h1>
        <div className={styles.checkoutSubtitle}>
          <span className={styles.processString}>{checkoutProcessString}</span>
          <span className={styles.periodLabel}>
            &nbsp;
            {productionPeriod}
          </span>
        </div>
      </div>
    </div>
    <div className={styles.checkoutSubtitle}>
      <DealershipSummary />
      <SubmissionButton disabled={!inCartView} />
    </div>
  </div>
);

CheckoutSummaryHeader.propTypes = {
  title: PropTypes.string.isRequired,
  checkoutProcessString: PropTypes.string.isRequired,
  productionPeriod: PropTypes.string.isRequired,
  inCartView: PropTypes.bool.isRequired,
};

export default enhance(CheckoutSummaryHeader);
